import { palette, global } from './config';

const doctorTheme = {
    colors: {
        app_bg: palette.white,
        black: palette.black,
        blackButtonBackground: palette.primary,
        border: palette.grey,
        borderSecondary: palette.silver,
        buttonGrey: palette.iron,
        disable: palette.grey,
        error: palette.red,
        formBlue: palette.pictonBlue,
        formNewFieldBlue: palette.dustyBlue,
        grey: palette.grey,
        headerBg: palette.alto,
        hover: palette.blue,
        inputBorder: palette.emperor,
        linkHover: palette.dustyBlue,
        paginationBackground: palette.pictonBlue,
        paginationBorder: palette.emperor40,
        placeholder: palette.emperor,
        primary: palette.pictonBlue,
        primaryButtonDisabled: palette.silver,
        profileBorder: palette.alto,
        profileImageBorder: palette.pictonBlue,
        secondary: palette.red,
        tableHeaderBorder: palette.dustyGray,
        text: palette.emperor,
        textAreaBg: palette.wildSand,
        textLine: palette.alto,
        transcriptionTextBorder: palette.emperor,
        waveBackground: palette.lightGrey,
        white: palette.white,
    },
    ...global,
};

export default doctorTheme;
